import React from "react";
import Moment from "react-moment";
import "moment-timezone";

const FormattedDate = ({ children }) => (
  <Moment tz="Europe/London" date={children} format="ddd Do MMM" />
);

export default FormattedDate;
